import { FC } from 'react';
import { useDoBorrow } from './BorrowForm';
import { BorrowPanel } from './BorrowPanel';

export const BorrowPanelController: FC = () => {
  const doBorrow = useDoBorrow();

  return <BorrowPanel doBorrow={doBorrow} />;
};
